<template>
  <div class="card shadow-sm rounded-5 text-center border-4" :class="color">
    <TrophyIcon v-if="isTopGroup" />
    <div class="card-header">
      <GroupIcon :index="index" :width="100" :name="name" />
      <div class="fw-bold" :class="`fs-${size}`">{{ name }}</div>
    </div>
    <div class="card-body d-flex justify-content-center p-5">
      <StarIcon :points="points" :color="color" />
    </div>
  </div>
</template>

<script>
import GroupIcon from "@/components/activity/GroupIcon.vue";
import TrophyIcon from "@/components/activity/TrophyIcon.vue";
import StarIcon from "@/components/activity/StarIcon.vue";

// Data
export default {
  name: "GroupCard",
  components: { GroupIcon, TrophyIcon, StarIcon },
  props: {
    size: {
      type: Number,
      default: 3
    },
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    points: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    isTopGroup: {
      type: Boolean,
      default: false
    }
  }
};
</script>
